import api from "Helpers/Api";

export default async function getBoletinsTypes() {
  const { data } = await api.get<string[]>("/boletins/types");

  return data;
}
